import React, { useEffect, useState } from 'react';
import { CheckCircle2, ShieldCheck, Mail, Clock, Zap, FlameIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function CheckoutSection() {
  const checkoutUrl = 'https://www.profepack.com/cart/48076302418176:1';
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev <= 1 ? 10 * 60 : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isUrgent = timeLeft < 120;
  return <section className="py-12 md:py-24 bg-gray-50" id="comprar" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="max-w-2xl mx-auto" data-id="element-39">
          {/* Section Header */}
          <div className="text-center mb-6 md:mb-10" data-id="element-40">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-200 rounded-full px-4 py-1.5 mb-4" data-id="element-41">
              <span className="relative flex h-2.5 w-2.5" data-id="element-42">
                <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-pulse-slow" data-id="element-43"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-44"></span>
              </span>
              <span className="text-orange-700 font-semibold text-xs md:text-sm uppercase tracking-wide" data-id="element-45">
                Oferta activa ahora
              </span>
            </div>

            <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-gray-900 mb-2 md:mb-3" data-id="element-46">
              Tu Pack Está Listo
            </h2>
            <p className="text-sm md:text-lg text-gray-500" data-id="element-47">
              Precio especial disponible por tiempo muy limitado
            </p>
          </div>

          {/* Main Card */}
          <Card className="overflow-visible border-0 shadow-2xl relative" style={{
          boxShadow: '0 0 0 2px #f9a8d4, 0 25px 50px -12px rgba(0,0,0,0.25), 0 0 60px rgba(236,72,153,0.15)'
        }} data-id="element-48">
            {/* Top urgency bar */}
            <div className={`w-full rounded-t-xl px-4 py-2.5 flex items-center justify-center gap-2 ${isUrgent ? 'bg-red-600' : 'bg-orange-500'} transition-colors duration-500`} data-id="element-49">
              <Clock className="w-4 h-4 text-white flex-shrink-0" data-id="element-50" />
              <span className="text-white text-xs md:text-sm font-semibold" data-id="element-51">
                La oferta expira en:
              </span>
              <span className={`font-black text-white text-base md:text-lg tabular-nums tracking-widest ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-52">
                {minutes}:{seconds}
              </span>
            </div>

            <div className="p-5 md:p-8 lg:p-10" data-id="element-53">
              {/* Social proof */}
              <div className="flex items-center justify-between mb-5 md:mb-6 flex-wrap gap-2" data-id="element-54">
                <div className="flex items-center gap-1.5 text-xs md:text-sm text-gray-700 font-medium" data-id="element-55">
                  <FlameIcon className="w-4 h-4 text-orange-500" aria-hidden="true" data-id="element-56" />
                  <span data-id="element-57">47 docentes compraron hoy</span>
                </div>
                <span className="bg-pink-100 text-pink-800 px-2.5 py-1 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-wide" data-id="element-58">
                  Oferta Limitada
                </span>
              </div>

              {/* Product title */}
              <h3 className="text-xl md:text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-1 md:mb-2 leading-tight" data-id="element-59">
                MegaPack Danza Lista
              </h3>
              <p className="text-sm md:text-lg text-gray-600 mb-5 md:mb-6" data-id="element-60">
                Todo lo que necesitás para dar clases increíbles
              </p>

              {/* Features */}
              <div className="mb-5 md:mb-7" data-id="element-61">
                <h4 className="text-xs md:text-sm font-bold text-gray-700 mb-3 md:mb-4 uppercase tracking-wider" data-id="element-62">
                  Incluye:
                </h4>
                <ul className="space-y-2 md:space-y-3" data-id="element-63">
                  <li className="flex items-start gap-2.5 text-sm md:text-base text-gray-700" data-id="element-64">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-65" />
                    <span data-id="element-66">6 Tomos Digitales Completos (3 a 18+ años)</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm md:text-base text-gray-700" data-id="element-67">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-68" />
                    <span data-id="element-69">Kit Muestras Sin Pánico (festival)</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm md:text-base text-gray-700" data-id="element-70">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-71" />
                    <span data-id="element-72">Generador de Aulas Llenas (marketing)</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm md:text-base text-gray-700" data-id="element-73">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-74" />
                    <span data-id="element-75">Biblioteca Musical BPM curada</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm md:text-base text-gray-700" data-id="element-76">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-77" />
                    <span data-id="element-78">Actualizaciones de por vida</span>
                  </li>
                </ul>
              </div>

              {/* Scarcity bar */}
              <div className="mb-5 md:mb-6 bg-orange-50 border border-orange-100 rounded-xl p-3 md:p-4" data-id="element-79">
                <div className="flex items-center justify-between mb-2" data-id="element-80">
                  <span className="text-xs md:text-sm font-bold text-orange-900" data-id="element-81">
                    🔥 Solo quedan 7 lugares a este precio
                  </span>
                  <span className="text-xs text-orange-800 font-semibold" data-id="element-82">
                    85% ocupado
                  </span>
                </div>
                <div className="w-full bg-orange-100 rounded-full h-2.5 overflow-hidden" role="progressbar" aria-valuenow={85} aria-valuemin={0} aria-valuemax={100} aria-label="85% de lugares ocupados" data-id="element-83">
                  <div className="h-full rounded-full bg-gradient-to-r from-orange-500 to-red-500" style={{
                  width: '85%'
                }} data-id="element-84" />
                </div>
              </div>

              {/* Price */}
              <div className="flex flex-col items-center mb-4 md:mb-5 border-t border-gray-100 pt-5 md:pt-6" data-id="element-85">
                <span className="mb-2 bg-green-500 text-white px-3 py-1.5 rounded-lg text-sm md:text-base font-black shadow-md inline-block" data-id="element-86">
                  🔥 -58% de descuento
                </span>
                <div className="flex flex-col items-center" data-id="element-87">
                  <span className="md:text-lg line-through font-medium text-[20px] text-[#FF0000]" data-id="element-88">
                    $47.900 ARS
                  </span>
                  <div className="flex items-baseline gap-2" data-id="element-89">
                    <span className="md:text-6xl font-black text-gray-900 tracking-tight text-[48px]" data-id="element-90">
                      $19.990
                    </span>
                    <span className="text-base md:text-xl font-bold text-gray-500" data-id="element-91">
                      ARS
                    </span>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mb-3" data-id="element-92">
                <button className="w-full py-4 md:py-5 px-6 rounded-xl font-black text-base md:text-xl text-white bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 shadow-lg hover:shadow-xl active:scale-[0.99] transition-colors duration-150 focus:outline-none focus:ring-4 focus:ring-orange-300" style={{
                animation: 'pulse-cta 2.5s ease-in-out infinite',
                willChange: 'transform, opacity'
              }} data-id="element-93">
                  🎯 Quiero el MegaPack Ahora
                </button>
              </a>

              {/* Below CTA */}
              <p className="text-center text-xs md:text-sm text-gray-600 mb-5 md:mb-7 flex items-center justify-center gap-1.5" data-id="element-94">
                <Zap className="w-3.5 h-3.5 text-amber-500" aria-hidden="true" data-id="element-95" />
                <span data-id="element-96">⚡ Acceso inmediato al comprar</span>
              </p>

              {/* Trust badges */}
              <div className="border-t border-gray-100 pt-4 md:pt-5" data-id="element-97">
                <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 text-xs md:text-sm text-gray-600" data-id="element-98">
                  <span className="flex items-center gap-1.5" data-id="element-99">
                    <ShieldCheck className="w-4 h-4 text-green-600" aria-hidden="true" data-id="element-100" />
                    <span className="font-semibold" data-id="element-101">Garantía 7 días</span>
                  </span>
                  <span className="text-gray-300 hidden md:inline" aria-hidden="true" data-id="element-102">
                    |
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-103">
                    <ShieldCheck className="w-4 h-4 text-blue-600" aria-hidden="true" data-id="element-104" />
                    <span className="font-semibold" data-id="element-105">
                      Pago seguro Mercado Pago
                    </span>
                  </span>
                  <span className="text-gray-300 hidden md:inline" aria-hidden="true" data-id="element-106">
                    |
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-107">
                    <Mail className="w-4 h-4 text-pink-600" aria-hidden="true" data-id="element-108" />
                    <span className="font-semibold" data-id="element-109">
                      PDF por email inmediato
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}